<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large" style="height: 550px">
      <header class="modal-card-head">
        <p class="modal-card-title">Generate Boleto</p>
      </header>
      <section class="modal-card-body" style="align-items: center">
        <label class="label">Banks</label>
        <div class="control is-grouped">
          <v-select
            :options="parseBancos(getBancos)"
            placeholder="Search Bank"
            label="name"
            v-model="invoice.banco"
            v-if="getBancos"
            style="width: 50%"
          >
          </v-select>
          <span class="notification is-danger" v-if="error !== ''">{{ error }}</span>
        </div>
        <div class="control is-grouped">
          <p class="control" style="width: 25%">
            <label class="label">Deadline</label>
            <datepicker
              ref="deadline"
              placeholder="Deadline"
              v-validate="'required'">
            </datepicker>
            <span v-if="invoice.deadline === 0" class="help is-danger">Informe o vencimento</span>
          </p>
          <div class="control" style="width: 25%" v-if="this.invoices[0].currency !== 'BRL'">
            <label class="label">Exchange</label>
            <input
              :class="{'input': true, 'is-danger': errors.has('exchange')}"
              name="exchange"
              id="exchange"
              type="text"
              placeholder="Inform Exchange"
              v-model.trim="exchange"
              v-validate="'required|decimal:10|min_value:0.1'"
              @change="setAmount()">
            <span v-show="errors.has('exchange')" class="help is-danger">{{ errors.first('exchange') }}</span>
          </div>
        </div>
        <table class="table" v-if="exchange > 0">
          <tr>
            <th>Invoice</th>
            <th>Price</th>
            <th>Exchange</th>
            <th>IOF</th>
            <th>Amount</th>
          </tr>
          <tr v-for="total in totals" :key="total.invoice">
            <td>#{{ total.invoice}}</td>
            <td>{{ Intl.NumberFormat('pt-br', {style: 'currency', currency: invoice.currencies[0]}).format(total.originalPrice) }}</td>
            <td>{{ exchange }}</td>
            <td>{{ Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(total.iof) }}</td>
            <td>{{ Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(total.exchangePrice) }}</td>
          </tr>
        </table>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a class="button is-primary" @click="close(true)">Cancel</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-disabled': errors.any() || inProgress || error !== '' || !invoice.banco, 'is-loading': inProgress}" @click="generate()">Generate</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import babelPolyfill from 'babel-polyfill'
  import vSelect from 'vue-select'
  import Datepicker from 'vue-bulma-datepicker'
  import 'vue-select/dist/vue-select.css'
  export default {
    props: {
      context: {
        type: Object
      },
      invoices: {
        type: Array,
        required: true
      },
      callback: {
        type: String
      }
    },
    data () {
      return {
        invoice: {
          invoices_id: [],
          currencies: [],
          originalPrices: [],
          exchangePrices: [],
          banco: '',
          deadline: ''
        },
        inProgress: false,
        error: '',
        getBancos: null,
        exchange: '',
        iof: '',
        iofPercent: 0,
        totals: []
      }
    },
    mounted () {
      this.$nextTick(() => {
        document.body.appendChild(this.$el)
        for (let index = 0; index < this.invoices.length; index++) {
          this.invoice.invoices_id[index] = this.invoices[index].invoice_id
          this.invoice.currencies[index] = this.invoices[index].currency
          this.invoice.originalPrices[index] = this.invoices[index].price
        }
        this.loadMethods()
        // Busca o IOF do backend
        this.context.$http.get(this.context.$store.state.config.apiURL + '/config/iof')
          .then((response) => {
            if (response && response.body && response.body.iof !== undefined) {
              // console.log('Body iof : ' + response.body.iof)
              this.iofPercent = response.body.iof
              // console.log('iof percent : ' + this.iofPercent)
            } else {
              this.iofPercent = 0
            }
          })
          .catch(() => {
            this.iofPercent = 0
          })
      })
    },
    methods: {
      loadMethods () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/bancos').then((response) => {
          this.getBancos = response.body
        }, (response) => {
        })
      },
      parseBancos (getBancos) {
        let getBancosTmp = getBancos.map((banco) => {
          let bancoOption = ''
          bancoOption = banco.nome + ' (Ag: ' + banco.agencia + ' / Cc: ' + banco.conta + ')'
          return {
            name: bancoOption,
            id: banco.id
          }
        })
        return getBancosTmp
      },
      setAmount () {
        this.totals = []
        for (let index = 0; index < this.invoice.originalPrices.length; index++) {
          const total = {}
          this.iof = parseFloat((this.invoice.originalPrices[index] * this.exchange * this.iofPercent)).toFixed(2)
          this.invoice.exchangePrices[index] = (parseFloat(this.invoice.originalPrices[index] * this.exchange) + parseFloat(this.iof)).toFixed(2)
          total.invoice = this.invoice.invoices_id[index]
          total.originalPrice = this.invoice.originalPrices[index]
          total.iof = this.iof
          total.exchangePrice = this.invoice.exchangePrices[index]
          this.totals.push(total)
        }
      },
      close (closeOnly, result) {
        if (!closeOnly) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      generate () {
        let result = ''
        this.inProgress = true
        if (window.confirm('Are you sure you want to generate a boleto for ' + this.invoice.banco.name + '?')) {
          this.invoice.deadline = this.$refs.deadline.datepicker.input.value
          if (!this.invoice.deadline) {
            this.invoice.deadline = 0
            this.inProgress = false
            return
          }
          this.error = ''
          this.context.$http.post(this.context.$store.state.config.apiURL + '/V2/invoice/generate_boleto', this.invoice).then((response) => {
            this.inProgress = false
            result = response.body
            this.close(false, result)
          }, (response) => {
            this.inProgress = false
            result = response.body.message
            this.close(false, result)
          })
        } else {
          this.inProgress = false
        }
      }
    },
    components: {
      Datepicker,
      babelPolyfill,
      vSelect
    }
  }
</script>

<style scoped>
  th, td {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// GenerateBoleto.vue?227dc638